/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, { useState, useContext, useCallback, useEffect } from 'react'
import { motion } from 'framer-motion';
import FilterModal from './FilterModal'
import moment from 'moment'
import { distributorService } from '../../../service/distributor.service';
import HeaderContext from '../../../Components/Context/HeaderContext';
import Pagination from '../../../Components/Pagination';
import EmptyOrderPage from '../../MyOrders/EmptyOrderPage';
import OrderListingSkeleton from '../../MyOrders/OrderListingSkeleton';
import { PriceHandler } from '../../../redux/helper/CamelCase'

const IndentReport = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [indentReportList, setIndentReportList] = useState([]);
    const [sortType, setsortType] = useState('CREATED_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [filterModal, setFilterModal] = useState(false)
    const [filterUrl, setfilterUrl] = useState('')
    const [Filter, setFilter] = useState({
        order_category:[],
        status:[],
        order_type:[],
    })
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');


    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;


    const handleIndentReports = useCallback((() => {
        distributorService.MISIndentReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setIndentReportList(response.data.data);
                setalldata(response);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue, exportSelected]);

    const handleExport = useCallback((() => {
        distributorService.MISIndentReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType, searchValue, filterValue, exportSelected ).then((response) => {
            if (response.data.success_status) {
                SetSuccessMessage(response.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(response.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        handleIndentReports();
    }, [handleIndentReports]);

    return (
        <div className="md:px-[46px] px-4 sm:pt-[30px] pt-3.5">
            {(loading && !emptyData) ? <OrderListingSkeleton /> : (         
                <div>
                    <div className="flex items-center justify-between flex-wrap pb-[10px]">
                        <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Indent Report</h5> 
                        <div className="lg:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                                <button 
                                    type="button" 
                                    className="flex items-center bg-[#F5F5FA] font-bold text-xs text-[#555259] border-2 border-[#E9EDF4] sm:py-2.5 py-1.5 px-5 rounded-[9px]" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#filtermodal"
                                    onClick={() =>setFilterModal(true)}
                                >
                                    {filterValue === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                                </button>
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false" 
                                        className="dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Generate Report
                                    </button>
                                    <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px]  ${exportClick ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9] sm:p-3.5 p-1.5`} 
                                        style={{zIndex : '9'}} 
                                        aria-labelledby="exportDropdown">
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"  
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('csv')}}

                                            >CSV</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected(`pdf-converter`)}
                                            >PDF</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected('excel')}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer">
                                    <input 
                                        type="text" 
                                        className="hidden lg:w-[200px] w-[160px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                        placeholder="Search"
                                        value={searchValue}
                                        onChange={(e) => {
                                            setsearchValue(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        autoComplete="off"
                                    />
                                    <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {indentReportList.length > 0 && (
                            <div className="overflow-auto dropdown-menu  pb-7 relative z-[6]" style={{height: 'calc(100vh - 297px)'}}>
                                <table className="w-full table-auto relative">
                                    <thead className='sticky top-0 left-0 z-[1]'>
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-2.5 sm:px-7 px-3 rounded-bl-lg rounded-tl-lg min-w-[210px] bg-[#555259] text-start sticky left-0" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Indent Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[150px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Order No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[210px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-start">
                                                    Order Acceptance No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[150px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Type
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[140px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Plant Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Source
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[240px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Created Date
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'CREATED_DATE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'CREATED_DATE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'CREATED_DATE+asc') {
                                                                    setsortType('CREATED_DATE+desc');
                                                                } else if (sortType === 'CREATED_DATE+desc') {
                                                                    setsortType('CREATED_DATE+asc');
                                                                } else {
                                                                    setsortType('CREATED_DATE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Total Lines
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'TOTAL_LINE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'TOTAL_LINE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'TOTAL_LINE+asc') {
                                                                    setsortType('TOTAL_LINE+desc');
                                                                } else if (sortType === 'TOTAL_LINE+desc') {
                                                                    setsortType('TOTAL_LINE+asc');
                                                                } else {
                                                                    setsortType('TOTAL_LINE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Amount
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'AMOUNT+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'AMOUNT+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'AMOUNT+asc') {
                                                                    setsortType('AMOUNT+desc');
                                                                } else if (sortType === 'AMOUNT+desc') {
                                                                    setsortType('AMOUNT+asc');
                                                                } else {
                                                                    setsortType('AMOUNT+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[160px] rounded-br-lg rounded-tr-lg text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Status
                                                </span>
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {indentReportList.length > 0 && indentReportList.map((item, idx) => (
                                            <tr key={item} className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td className="sticky left-0 text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                                    {item?.INDENT_NUMBER}                
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_NUMBER}                     
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_ACCEPTANCE_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_TYPE}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.PLANT_NAME}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_SOURCE}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_CATEGORTY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {moment(item?.CREATED_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.TOTAL_LINE}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {PriceHandler(item?.AMOUNT)}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.STATUS}
                                                </td>
                                            </tr>  
                                        ))}
                                          
                                    </tbody>
                                </table>
                            </div>
                        )}             
                        {!loading && indentReportList && indentReportList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                totalPage={totalPage}
                                List={alldata}
                                currentPage={currentPage}
                            />
                        )}
                        {filterModal && 
                        <FilterModal 
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterUrl={filterUrl}
                            setfilterUrl={setfilterUrl}
                            selected={selected}
                            setselected={setselected}
                            handleIndentReports={handleIndentReports}
                            handleFilter={handleFilter}
                            SetSuccessMessage={SetSuccessMessage} 
                            filterValue={filterValue} 
                            setfilterValue={setfilterValue}                        
                        />}
                    </div>
                    {emptyData && <EmptyOrderPage search="yes" text="no Indent Report" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}
                </div>
            )}
        </div>
    )
}

export default IndentReport
